import { PureComponent } from "react";
import HomepageSyncComponent from "/components/pages/external/homepage-sync/homepage-sync-component";

export default class HomepageSync extends PureComponent {
  static async getInitialProps() {
    return { options: { parentTargetOrigin: process.env.AUTH_PLATFORM_PATH } };
  }
  render() {
    const { options } = this.props;
    return <HomepageSyncComponent {...options} />;
  }
}

HomepageSync.defaultProps = {
  options: {}
};
